export enum TopNavigationVersion {
    V2 = 'V2',
    V3 = 'V3',
}
